import { createSvgIcon } from '@mui/material';

const BurgerIcon = createSvgIcon(
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='8' fill='#F6F8FF' />
    <rect x='13' y='14' width='14' height='2' rx='1' fill='#1749D1' />
    <rect x='13' y='19' width='14' height='2' rx='1' fill='#1749D1' />
    <rect x='13' y='24' width='14' height='2' rx='1' fill='#1749D1' />
  </svg>,
  'Burger',
);

export default BurgerIcon;
